import { Node, nodeInputRule, ReactNodeViewRenderer } from '@tiptap/react'
import { Plugin, PluginKey } from 'prosemirror-state'
import { VideoNode } from './video-node'
// import { VideoNode } from './video-node'

export interface VideoOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    video: {
      /**
       * Set a video node
       */
      setVideo: (src: string) => ReturnType
      /**
       * Toggle a video
       */
      toggleVideo: (src: string) => ReturnType
    }
  }
}

const VIDEO_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const Video = Node.create({
  name: 'video',
  draggable: true,
  group: 'block',

  addOptions() {
    return {
      uploadVideo: (v: any) => {},
    }
  },

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('src'),
        renderHTML: (attrs) => ({ src: attrs.src }),
      },
      source_id: {
        default: null,
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('source_id'),
        renderHTML: (attrs) => ({ source_id: attrs['source_id'] }),
      },
      controlsList: {
        default: 'nodownload',
        parseHTML: (el) => (el as HTMLSpanElement).getAttribute('controlsList'),
        renderHTML: (attrs) => ({ controlsList: attrs['controlsList'] }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'video',
        getAttrs: (el) => ({
          src: (el as HTMLVideoElement).getAttribute('src'),
          source_id: (el as HTMLVideoElement).getAttribute('source_id'),
        }),
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'video',
      { controls: 'true', borderRadius: 16, style: 'width: 100%', ...HTMLAttributes },
      ['source', HTMLAttributes],
    ]
  },

  // addCommands() {
  //   return {
  //     setVideo:
  //       (src: string) =>
  //       ({ commands }) => {
  //         commands.insertContent(
  //           `<video controls="true" controlsList="nodownload" style="width: 100%" src="${src}" />`,
  //         )
  //       },

  //     toggleVideo:
  //       () =>
  //       ({ commands }) =>
  //         commands.toggleNode(this.name, 'paragraph'),
  //   }
  // },

  addInputRules() {
    return [
      nodeInputRule({
        find: VIDEO_INPUT_REGEX,
        type: this.type,
        getAttributes: (match) => {
          const [, , src] = match

          return { src }
        },
      }),
    ]
  },

  addProseMirrorPlugins() {
    const upload = this.options.uploadVideo
    const reader = new FileReader()
    return [
      new Plugin({
        key: new PluginKey('videoDropPlugin'),

        props: {
          handleDOMEvents: {
            drop(view, event) {
              const {
                state: { schema, tr },
                dispatch,
              } = view

              const hasFiles =
                event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length

              if (!hasFiles) {
                return false
              }

              const videos = Array.from(event.dataTransfer.files).filter((file) =>
                /video/i.test(file.type),
              )

              if (videos.length === 0) {
                return false
              }

              event.preventDefault()

              const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY })

              upload(videos[0]).then((data) => {
                const { url, source_id } = data
                reader.onload = (readerEvent) => {
                  const node = schema.nodes.video.create({
                    // src: url,
                    src: readerEvent.target?.result,
                    source_id,
                    controlsList: 'nodownload',
                  })

                  if (coordinates && typeof coordinates.pos === 'number') {
                    const transaction = tr.insert(coordinates?.pos, node)
                    dispatch(transaction)
                  }
                }

                reader.readAsDataURL(videos[0])
              })

              return true
            },
          },
        },
      }),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoNode, {
      as: 'div',
      contentDOMElementTag: 'div',
      attrs: {
        ...this.options.HTMLAttributes,
      },
    })
  },
})
